import {EntityData} from "@fedeltapointofsale/data-client";

export class PivotQueryRequestData extends EntityData<PivotQueryRequestData> {
    requestId: string;

    /**
     * Indicates that the request is being resent. The requestId should be the same as the previous attempt that
     * timed out
     */
    resubmission: boolean;

    cubeName: string;
    rows: string[][];
    rowMeasures: string[];
    columns: string[][];
    columnMeasures: string[];
    slicers: string[];
    /**
     * Base date range. Null is all dates
     */
    dateRangeRef: string;
    restrictedStartDate: string;
    restrictedEndDate: string;
    restrictedDateLevel: string;

    override toJSONString(): string {
        return JSON.stringify(this);
    }
}
